export default __webpack_public_path__ + "static/media/heart-red.79b11d23.png";